import '../css/app.css';
import './bootstrap';

import React from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import Clarity from '@microsoft/clarity';

const appName = import.meta.env.VITE_APP_NAME || 'WASHI';

if (import.meta.env.PROD) {
  posthog.init('phc_tKXQ4Ylowr5ZnAV9xNcMdupVDApxdet2EWSoNACYMIN', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
  });

  const clarityProjectId = 'p1k5rnbc9o';
  Clarity.init(clarityProjectId);
}

createInertiaApp({
  title: title => `${title} - ${appName}`,
  resolve: name =>
    resolvePageComponent(
      `./pages/${name}.tsx`,
      import.meta.glob(['./pages/**/*.tsx', '!./pages/**/*.test.tsx', '!./pages/**/*.spec.tsx']),
    ),
  setup({ el, App, props }) {
    const root = createRoot(el);

    root.render(
      <React.StrictMode>
        <PostHogProvider client={posthog}>
          <App {...props} />
        </PostHogProvider>
      </React.StrictMode>,
    );
  },
  progress: {
    color: '#4B5563',
  },
});
